import solucion1 from '../../../../assets/img/movil/soluciones.jpg';
import './CMNetworking.css';

function CMNetworking() {

    return (
        <div id="CMNetworking">
            <section id="Net__head">
                <h2>Soluciones de Networking</h2>
                <ul>
                    <li>Inicio</li>
                    <li>/</li>
                    <li>Servicios</li>
                    <li>/</li>
                    <li>Soluciones de Networking</li>
                </ul>
            </section>
            <section id="Net__section2">
                <figure id="Net-content">
                    <img src={solucion1}  alt="Soluciones Infrasol"/>
                </figure>
                <div id="Net-text">
                    <p id="Net-text__p1">Contamos con ingenieros especializados<strong> en atender sus proyectos.</strong></p>
                    <p id="Net-text__p2">INFRASOL ofrece diseño, suministro e instalación de redes cableadas e inalámbricas, así como servicios de consultoría, gestión de proyectos, planificación, pruebas, mantenimiento y soporte en Networking, garantizando redes seguras, eficientes y escalables.</p>
                </div>
            </section>
            <section id="Net__section3">
                <div id="Nets3-content1">
                    <h2>Comunicaciones IP, Telefonía IP</h2>
                    <div></div>
                    <ul>
                        <li><strong>Comunicaciones IP (VoIP): </strong>Facilitamos la convergencia de datos, voz y video en una sola red segura, reduciendo la complejidad de la infraestructura y aumentando la eficiencia operativa. Nuestras soluciones permiten adaptarse rápidamente a los cambios tecnológicos y lograr una reducción significativa de costos operativos.</li>
                        <li><strong>Telefonía IP: </strong>Permite transmitir comunicaciones de voz sobre redes de datos basadas en el estándar IP, integrando aplicaciones de voz y datos en una única plataforma. Las soluciones incluyen: gateways de voz H.323 y SIP, teléfonos IP de distintas características, integración con sistemas de telefonía tradicional y servicios de mensajería e integración con aplicaciones empresariales.</li>
                    </ul>
                </div>
                <div id="Nets3-content2">
                    <h2>Routing, Switching y Wireless</h2>
                    <div></div>
                    <ul>
                        <li><strong>Routing y Switching: </strong>Contamos con la experiencia y los recursos necesarios para diseñar, implementar y brindar soporte al núcleo de la infraestructura de red de pequeñas y medianas empresas. Solucionamos problemas en redes LAN y WAN, redes de acceso remoto e infraestructura basada en tecnología Ethernet de alta velocidad y equipos Catalyst.</li>
                        <li><strong>Acceso Inalámbrico (Wireless): </strong>Brindamos soluciones inalámbricas seguras y de alto rendimiento para soportar la movilidad de voz, video y datos mediante access points, routers, adaptadores inalámbricos, seguridad HotSpot y software de gestión.</li>
                        <li><strong>Acceso Inalámbrico local: </strong>Seguridad y alto rendimiento para apoyar la movilidad de voz, video y datos, con equipos y configuración adecuados a cada requerimiento.</li>
                        <li><strong>Acceso Inalámbrico remoto: </strong>Soluciones de conectividad inalámbrica de banda ancha para empresas de telecomunicaciones, proveedores de Internet (ISP) y operadores de redes privadas, permitiendo enlaces de distintas velocidades y alcances.</li>
                    </ul>
                </div>
            </section>
        </div>
    );
}

export default CMNetworking;